import type * as sdk from '@seek/hirer-job-application-service-sdk';

import type { ApplicationAttachmentType } from 'src/App/YourCandidatesPage/graphql/hirer-types.generated';

import configurationService from '../services/configurationService';

export type AttachmentType = Exclude<ApplicationAttachmentType, 'OTHER'>;

export const NON_PDF_ATTACHMENT_TYPE_MAPPING: Record<
  AttachmentType,
  sdk.GetApplicationAttachment.RequestInput['attachmentType']
> = {
  COVER_LETTER: 'CoverLetter',
  RESUME: 'Resume',
  SELECTION_CRITERIA: 'SelectionCriteria',
};

export const attachmentDownloadUrl = (
  prospectId: string,
  attachmentId: string,
) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';
  return `${prefix}/api/v2/prospectAttachment/getAttachment?prospectID=${prospectId}&attachmentID=${attachmentId}`;
};

export const attachmentUrlV2 = ({
  jobId,
  applicationCorrelationId,
  attachmentType,
  actionType,
  blobId,
}: sdk.GetApplicationAttachment.RequestInput) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';

  const searchParams = new URLSearchParams();
  searchParams.append('jobId', jobId);
  searchParams.append('applicationCorrelationId', applicationCorrelationId);
  searchParams.append('attachmentType', attachmentType);
  searchParams.append('actionType', actionType);
  searchParams.append('blobId', blobId);

  return `${prefix}/attachment/applications?${searchParams.toString()}`;
};

export const attachmentPreviewUrl = (
  prospectId: string,
  attachmentId: string,
) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';

  return `${prefix}/api/v2/prospectAttachment/getAttachmentFile?prospectId=${prospectId}&attachmentId=${attachmentId}&preview=true`;
};
